import React, { useEffect, useRef, useState } from "react";
import { ABtn, AResult } from "./arcadeUi";

export default function ThumbWrestling() {
  const [pos, setPos] = useState(50); // 0 = CPU pins you, 100 = you pin CPU
  const [stage, setStage] = useState("idle"); // idle | count | fight | over
  const [count, setCount] = useState(3);
  const cpuTimer = useRef(null);
  const cdTimer = useRef(null);

  const clearAll = () => { clearInterval(cpuTimer.current); clearInterval(cdTimer.current); };

  const start = () => {
    clearAll();
    setPos(50); setCount(3); setStage("count");
    cdTimer.current = setInterval(() => {
      setCount((c) => {
        if (c <= 1) { clearInterval(cdTimer.current); beginFight(); return 0; }
        return c - 1;
      });
    }, 700);
  };

  const beginFight = () => {
    setStage("fight");
    cpuTimer.current = setInterval(() => {
      setPos((p) => {
        const np = Math.max(0, p - (1.4 + Math.random() * 1.6));
        if (np <= 0) { clearAll(); setStage("over"); return 0; }
        return np;
      });
    }, 140);
  };

  const push = () => {
    if (stage !== "fight") return;
    setPos((p) => {
      const np = Math.min(100, p + 5.5);
      if (np >= 100) { clearAll(); setStage("over"); return 100; }
      return np;
    });
  };

  useEffect(() => () => clearAll(), []);
  const won = stage === "over" ? pos >= 100 : null;

  return (
    <div className="w-full select-none text-center">
      <p className="mb-3 text-sm text-kirana-brown/70">"One-two-three-four, I declare a thumb war!" — mash <b>PIN!</b> to push the CPU thumb to your side.</p>

      <div className="relative mx-auto h-12 w-full max-w-md overflow-hidden rounded-full border-[3px] border-kirana-brown bg-gradient-to-r from-kirana-red via-kirana-gold to-kirana-green">
        <div className="pointer-events-none absolute inset-y-0 left-2 flex items-center text-xs font-bold text-white/90">CPU</div>
        <div className="pointer-events-none absolute inset-y-0 right-2 flex items-center text-xs font-bold text-white/90">YOU</div>
        <div className="absolute top-1/2 -translate-y-1/2 transition-[left] duration-100" style={{ left: `calc(${pos}% - 18px)` }}>
          <span data-testid="tw-thumb" className="text-4xl drop-shadow">👍</span>
        </div>
      </div>

      <div className="mt-5 flex min-h-[4rem] items-center justify-center">
        {stage === "idle" && <ABtn data-testid="tw-start" onClick={start} tone="gold">Start Thumb War</ABtn>}
        {stage === "count" && <p data-testid="tw-count" className="font-signboard text-5xl font-bold text-kirana-red">{count === 0 ? "GO!" : count}</p>}
        {stage === "fight" && (
          <ABtn data-testid="tw-push" onPointerDown={(e) => { e.preventDefault(); push(); }} tone="red" className="px-12 py-4 text-lg">PIN! 👍</ABtn>
        )}
      </div>

      {stage === "over" && (
        <>
          <AResult testId="tw-result" win={won} text={won ? "Pinned! You Win 🎉" : "CPU pinned you 😜"} />
          <div className="mt-3 flex justify-center"><ABtn data-testid="tw-again" onClick={start} tone="green">Rematch</ABtn></div>
        </>
      )}
    </div>
  );
}
